"use strict";
// shared-types/src/messaging/follow-activity.ts
// Consumers: lambda-utilities (producer helper), lambda-follow-activity (worker), lambda-secure (call sites)
Object.defineProperty(exports, "__esModule", { value: true });
